export default "__VITE_ASSET__D1B49LJQ__"